import { DatePicker as DatePickerAntd, DatePickerProps } from "antd";
export const DatePicker: React.FC<DatePickerProps & { readOnly?: boolean }> = ({
  readOnly,
  ...props
}) => <DatePickerAntd {...props} open={readOnly ? false : undefined} />;
